import React from 'react';
import './Advertisement.css';

// Import advertisement assets with unique names
import adGif1 from '../assets/advertisements/1.gif';
import adGif2 from '../assets/advertisements/2.gif';
import adImage2 from '../assets/advertisements/3.jpg';
import adGif4 from '../assets/advertisements/4.gif';
import adGif5 from '../assets/advertisements/5.gif'

function Advertisement() {
  return (
    <div className="ad-container">

      {/* Ad 1: Refah Bank */}
      <a
        href="https://www.refah-bank.ir/FaraLig"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={adGif4}
          alt="بانک رفاه کارگران - آگهی ۱"
          className="ad-image"
        />
      </a>




      {/* Ad 2: Refah Bank */}
      <a
        href="https://www.refah-bank.ir/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={adGif1}
          alt="بانک رفاه کارگران - آگهی ۱"
          className="ad-image"
        />
      </a>

      

      {/* Ad 3: Bank Melli Iran */}
      <a
        href="https://www.bmi.ir/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={adGif5}
          alt="بانک ملی ایران - آگهی ۳"
          className="ad-image"
        />
      </a>
    </div>
  );
}

export default Advertisement;
